import { render, staticRenderFns } from "./dataChangeAction.vue?vue&type=template&id=14e5a560"
import script from "./dataChangeAction.vue?vue&type=script&lang=js"
export * from "./dataChangeAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports